import axios from 'axios';
import { API } from '@config/common';

export const data = {
  opt_device_type: '',
  file_data: {},
  mov_path: '',
  sign_type: [],
  img_list: [],
  role_code: sessionStorage.getItem('user_role_code'),
  product_type_id: '',
  feature: {},
  is_view_control: false,
  user_id: '',
};

// eslint-disable-next-line camelcase
export const product_type_info = {
  h_res: 0, // 가로 해상도
  v_res: 0, // 세로 해상도
  rotate: 'H', // 화면 방향 (H:가로, V:세로)
  columns: 1, // 가로 장치 수
  rows: 1, // 세로 장치 수
  contents_json: undefined, // 애니메이션 기본값 정의
};

/*
 * 파일 업로드
 * 파일 업로드 화면 -> 다음버튼 클릭
 */
export const fileUpload = (formData) => {
  return axios({
    method: 'post',
    url: API.CONVERT_VIDEO,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'multipart/form-data',
    },
    data: formData,
  });
};

export const videoMaking = (formData) => {
  return axios({
    method: 'post',
    url: formData.get('url'),
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'multipart/form-data',
    },
    data: formData,
  });
};

/*
 * 사진 편집
 * 사용자 제작 이미지 업로드 -> 다운로드 버튼 클릭
 */
export const pictureToVideo = (formData) => {
  return axios({
    method: 'post',
    url: formData.get('url'),
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'multipart/form-data',
    },
    data: formData,
  });
};

export const encodingState = (jobId) => {
  return axios({
    method: 'get',
    url: API.API_ENCODING_STATE + jobId,
    headers: { authorization: sessionStorage.getItem('accessToken') },
  });
};

export const videoDownload = (jobId) => {
  return axios({
    method: 'get',
    url: API.API_VIDEO_DOWNLOAD + jobId,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    responseType: 'arraybuffer',
  });
};

export const captureFileDownload = (jobId) => {
  return axios({
    method: 'get',
    url: API.API_THEME_CONVERT_CAPTUREFILE + jobId,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    data: null,
    responseType: 'arraybuffer',
  });
};

export const webViewVideoDownload = (jobId) => {
  return axios({
    method: 'get',
    url: API.API_APP_VIDEO_DOWNLOAD + jobId,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    data: null,
  });
};

export const themeView = ({
  page,
  length,
  categories,
  search_column: searchColumn,
  search_value: searchValue,
  product_type_id: productTypeId,
  user_id: userId,
}) => {
  return axios({
    method: 'get',
    url: API.API_THEME,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    params: {
      page,
      length,
      categories,
      search_column: searchColumn,
      search_value: searchValue,
      product_type_id: productTypeId,
      user_id: userId,
    },
  });
};

export const themeViewThumbnail = (contentId) => {
  return axios({
    method: 'get',
    url: `${API.API_THEME_INFO}${contentId}/thumbnail`,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    data: null,
    responseType: 'arraybuffer',
  });
};

export const imgServerRequest = (themeId, userId) => {
  let url = '';

  if (userId) {
    url = `${API.API_THEME_CONVERT}${themeId}?user_id=${userId}`;
  } else {
    url = API.API_THEME_CONVERT + themeId;
  }

  return axios({
    method: 'get',
    url,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    data: null,
  });
};

export const categorySelect = () => {
  return axios({
    method: 'get',
    url: API.API_THMENE_CATEGORY,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    data: null,
  });
};

export const themeInfo = (themeId) => {
  return axios({
    method: 'get',
    url: API.API_THEME + themeId,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    data: null,
  });
};

export const themePreview = (themeId) => {
  return axios({
    method: 'get',
    url: `${API.API_THEME_INFO}${themeId}/preview`,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    data: null,
    responseType: 'arraybuffer',
  });
};

export default {
  data,
  product_type_info,
  fileUpload,
  videoMaking,
  pictureToVideo,
  encodingState,
  videoDownload,
  captureFileDownload,
  webViewVideoDownload,
  themeView,
  themeViewThumbnail,
  imgServerRequest,
  categorySelect,
  themeInfo,
  themePreview,
};
